export function getTypeTag(respondida: boolean) {
  if (respondida) {
    return "Respondida";
  }
  return "Responder";
}
